<template>
  <div class="vipContribute">
    <div class="vipContribute-name">
      <span>会员贡献价值分析</span>
    </div>

    <div class="selectCont">
      <div class="basics">
        <span>基础指标：</span>
        <el-checkbox
          v-for="(item, index) in basicsData"
          :key="index"
          v-model="item.state"
        >{{item.title}}</el-checkbox>
      </div>
      <div class="basics">
        <span>成交指标：</span>
        <el-checkbox
          v-for="(item, index) in bargainData"
          :key="index"
          v-model="item.state"
        >{{ item.title }}</el-checkbox>
      </div>
    </div>

    <div class="dataTable">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="客户类型" width="240" fixed></el-table-column>
        <template v-for="(item, index) in basicsData">
          <el-table-column
            :key="index"
            prop="name"
            :label="item.title"
            min-width="180"
            v-if="item.state"
          ></el-table-column>
        </template>
        <template v-for="(item, index) in bargainData">
          <el-table-column
            :key="index"
            prop="name"
            :label="item.title"
            min-width="180"
            v-if="item.state"
          ></el-table-column>
        </template>
      </el-table>
    </div>

    <div class="vipTendencyHint">
      <div class="vipTendencyHint_img">
        <img src="../../../../public/img/vipImg/dataAnalyze.png" alt />
      </div>
      <div class="vipTendencyHint_Cont">
        <p>数据分析思路</p>
        <p>会员等级数据分析，可以观察一段时间内各个会员等级的客户数和客户成交数据情况，会员数量越多，并且支付金额越高，说明店铺会员贡献度越高。可以采取给会员发放优惠券或者配置会员成交任务，从而来提升会员的贡献价值。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio1: "1",
      tableData: [],
      basicsData: [
        {
          title: "累积会员数",
          state: true
        },
        {
          title: "累积会员占比",
          state: false
        }
      ],
      bargainData: [
        {
          title: "成交会员数",
          state: false
        },
        {
          title: "成交会员占比",
          state: false
        },
        {
          title: "支付订单数",
          state: false
        },
        {
          title: "客单价",
          state: false
        },
        {
          title: "支付金额",
          state: false
        },
        {
          title: "支付金额占比",
          state: false
        },
        {
          title: "人均消费频次",
          state: false
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.vipContribute {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipContribute-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }

  .selectCont {
    padding: 16px;
    background: #f7f8fa;
    margin-bottom: 14px;

    .basics {
      font-size: 14px;
      margin-bottom: 14px;
    }
  }

  .dataTable {
    margin-bottom: 14px;

  }
  .vipTendencyHint {
    padding: 16px;
    display: flex;
    background: #f7f8fa;
    .vipTendencyHint_img {
      width: 30px;
      img {
        width: 100%;
      }
    }
    .vipTendencyHint_Cont {
      margin-left: 20px;
      height: 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss">
.vipContribute {
  .el-table {
    th {
      background-color: #f7f8fa;
    }
  }
}
</style>
